import React from 'react';
import shawnPic from '@/components/entry/images/shawn.png';
import propTypes from '@/components/entry/components/propTypes';

const MobileEntry = (props) => {
  let className;

  if (props.online) {
    className = props.newMessageCount
      ? 'xg-entry-message-count'
      : 'xg-entry-message-count hide';
  } else {
    className = props.newMessageCount
      ? 'xg-entry-message-count offline'
      : 'xg-entry-message-count hide';
  }

  return (
    <div id="xg-entry" className="xg-entry" onClick={props.onClick}>
      {/* 提示语和图片 */}
      <div className={props.online ? 'xg-entry-wrapper' : 'xg-entry-wrapper offline'}>
        <img src={shawnPic} alt="" />
        <span className="mobile-xg-entry-words">咨询老师</span>
      </div>
      {/* 提示语和图片_end */}
      {/* 未读消息 */}
      <div
        className={className}
      >
        {props.newMessageCount}
      </div>
      {/* 未读消息_end */}
    </div>
  );
};

MobileEntry.propTypes = propTypes;

export default MobileEntry;
